import { Chakra, Icons } from "@airhelp/react-ui-components";
import ActionButtons from "../ActionButtons";
import MenuItems from "../MenuItems";
import type { MobileMenuProps } from "./MobileMenu.d";

const { useDisclosure, Box, Drawer, DrawerOverlay, DrawerContent, DrawerBody, DrawerCloseButton, DrawerFooter } =
  Chakra;

const MobileMenu = ({ menuItems, buttons }: MobileMenuProps) => {
  const { isOpen, onOpen, onClose } = useDisclosure();

  return (
    <>
      <Box d={{ base: "block", lg: "none" }} onClick={onOpen} cursor="pointer" py="1" data-testid="ah-plus-mobile-menu">
        <Icons.Menu boxSize={6} mb="2px" />
      </Box>
      <Drawer isOpen={isOpen} placement="right" onClose={onClose}>
        <DrawerOverlay />
        <DrawerContent>
          <DrawerCloseButton
            size="lg"
            color="primary.900"
            _hover={{ color: "primary.500", bg: "white" }}
            _active={{ color: "primary.700", bg: "white" }}
            rounded="full"
            mt={1}
          />
          <DrawerBody px={12} pt={16} fontSize={{ base: 18, md: 16 }}>
            <MenuItems menuItems={menuItems} onClose={onClose} />
          </DrawerBody>
          <DrawerFooter>
            <ActionButtons buttons={buttons} />
          </DrawerFooter>
        </DrawerContent>
      </Drawer>
    </>
  );
};

export default MobileMenu;
